import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 213  -  二周目变量
 */

export default class EventVarsEx extends EventBase {
  private static normalizeParameter(param?: string[]) {
    const next = [...(param ?? ['0', '0', '0', '0', '', '0', '-1,0', '-1,0'])]
    while (next.length < 8) {
      next.push(next.length === 6 || next.length === 7 ? '-1,0' : '')
    }
    return next
  }
  /**
   * 构造函数
   */
  constructor(param?: string[]) {
    super()
    this.Parameter = EventVarsEx.normalizeParameter(param)
  }

  // #region 事件内关键属性参数
  /**
   * 数值索引
   */
  get Index() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set Index(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 操作符id(=,+=,-=,*=,/=,%=)(0,1,2,3,4,5)
   */
  get Operator() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set Operator(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /// <summary>
  /// 操作数为常量(0)、其他数值(1)、随机数(2)、二周目变量(3)、索引变量(4)、
  /// 服务器时间变量(5)、 鲜花数(6)、最大值(7)、最小值(8)、任务(9)、本地时间变量(10)
  /// </summary>
  get Type() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set Type(value) {
    this.Parameter![2] = value.toString()
  }

  /**
   * 值
   */
  get Value() {
    return this.Parameter?.[3] ?? ''
  }
  set Value(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    let isr = this.Parameter![4]
    if (this.Parameter![4].indexOf('|&;') !== -1) {
      const isrArr = this.Parameter![4].split('|&;')
      if (isrArr != null && isrArr.length >= 1) {
        isr = isrArr[0]
      }
    }
    return isr
  }
  set Description(value) {
    //this.SetProperty(this.Parameter, '4', value.toString());
    this.Parameter![4] = `${value}|&;${this.IsResultMinus ? 'ON' : 'OFF'}`
  }

  /**
   * 数值(0)或索引(1)
   */
  get IsIndex() {
    return this.Parameter?.[5] === '1'
  }
  set IsIndex(value) {
    this.Parameter![5] = !value ? '0' : '1'
  }

  /**
   * 值的整合变量信息
   */
  get valueUnitInfo() {
    return this.Parameter?.[6] ?? '-1,0'
  }
  set valueUnitInfo(value) {
    this.Parameter![6] = value?.toString() || '-1,0'
  }

  /**
   * 兼容旧工程的索引整合变量信息位。
   */
  get keyUnitInfo() {
    return this.Parameter?.[7] ?? '-1,0'
  }
  set keyUnitInfo(value) {
    this.Parameter![7] = value?.toString() || '-1,0'
  }

  /**
   * 当选择为服务器时间时判断是否设置未获取成功返回-1
   */
  get IsResultMinus() {
    let isr = false
    if (this.Parameter![4].indexOf('|&;') !== -1) {
      const isrArr = this.Parameter![4].split('|&;')
      if (isrArr != null && isrArr.length >= 2 && isrArr[1] == 'ON') {
        isr = true
      }
    }
    return isr
  }
  set IsResultMinus(value) {
    this.Parameter![4] = `${this.Description}|&;${value ? 'ON' : 'OFF'}`
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.VarsEx

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
  /**
   * 返回源参数集
   */
  /// <returns></returns>
  public GetParameter() {
    return this.Parameter
  }
}
